

















































import Vue from 'vue'
export default Vue.extend({
    props: {
        articles: {
            type: Array,
            default: null
        },
        buttons: {
            type: Array,
            default: null
        },
        content: {
            type: String,
            default: null
        },
        subject: {
            type: String,
            default: null
        },
        title: {
            type: String,
            default: null
        },
        video: {
            type: String,
            default: null
        },
        image: {
            type: String,
            default: null
        }
    },
    computed: {
        isAndroid(): boolean {
            return this.$store.getters.isMobile('nonIos')
        },
        isApp(): boolean {
            return this.$store.getters.isApp
        },
        videoWidth(): string {
            return '200px'
        }
    },
    methods: {
        goToArticle(article: URL): void {
            window.open(article.href, this.isApp ? '_system' : '_blank')
        }
    }
})
